<div class="container-fluid no-gutters">
  <!-- init header content -->
  <div class="row my-3">
    <div class="col-md-12">
      <button *ngIf="ShowSaveButton" class="q-btn q-success" title="Enregistrer" (click)="CanceledToGoogle(false, ConfirmUpdate)">
        <i class="fas icon fa-save"></i>
      </button>
      <button *ngIf="eventMode && eventMode === 2 && ShowRemoveButton" class="q-btn q-danger" title="Supprimer" data-toggle="modal" data-target="#ModalDelete" #modalDeleteBtn>
        <i class="fas fa-trash-alt"></i>
      </button>
      <button *ngIf="zoom && ShowSaveButton" class="q-btn q-primary ml-5" title="sauvegarder et ouvrir les options de vidéo-conférence" (click)="CanceledToGoogle(true, ConfirmUpdate)">
        <i class="fas fa-video mr-2"></i>
        Salle Virtuelle
      </button>
    </div>
  </div>
  <!-- end  header content -->
  <!-- init body content -->
  <div class="row no-gutters">
    <!-- init left column -->
    <div class="col-md-4 col-lg-3" *ngIf="dataRdv">
      <div class="container-fluid no-gutters">
        <!-- title -->
        <div class="row">
          <div class="col-12">
            <h3 class="q-c-main">
              <i class="far fa-calendar-alt q-icon-title" aria-hidden="true"></i>&nbsp;
              <strong>Création Rendez-vous</strong>
            </h3>
          </div>
        </div>
        <!-- input text search stages -->
        <q-autosearch *ngIf="dataRdv.RdvSelectedClient !== undefined && dataRdv.RdvSelectedClient !== null"
                      [Mode]="'CLIENTETTOUS'"
                      [InputText]="dataRdv.RdvSelectedClient.Text"
                      (SetInput)="getSelectedElement($event)"
                      CustomClass="focus"
                      [IsDisabled]="!!strClientId && strClientId != '0' && !!dataRdv?.RdvSelectedClient?.Text"></q-autosearch>
        <!-- add contacts -->
        <div class="col-12 mt-4 mb-2" *ngIf="dataRdv.ListContacts && dataRdv.ListContacts.length > 0">
          <button type="button" class="q-btn q-secondary q-btn-add" title="Ajouter des contacts" [ngbPopover]="popContactContent" [popoverTitle]="popContactTitle" placement="bottom" popoverClass="q-popover" [autoClose]="'outside'">
            <span class="ml-2">Contacts</span>
            <i class="fas fa-plus float-right mt-1 mr-1"></i>
          </button>
          <div class="col-6" *ngIf="dataRdv && dataRdv.ListContacts && oneContactSelected()">
            <div class="checkbox checkbox-switch-sm switch-primary ml-3">
              <label class="mt-1">
                <input type="checkbox" [(ngModel)]="dataRdv.IsSendInvitation" />
                <span></span>
              </label>
              <strong class="q-smaller">Notifier par email</strong>
            </div>
          </div>
        </div>
        <!-- list contacts -->
        <div class="col-12 p-3 q-zone-participant" *ngIf="dataRdv && dataRdv.ListContacts && afficheZoneContact(dataRdv.ListContacts)">
          <ng-container *ngFor="let contact of dataRdv.ListContacts">
            <ng-container *ngIf="contact.Key">
              <div class="row q-line-user px-2"
                   placement="bottom top auto"
                   [ngbPopover]="contactPopover"
                   triggers="mouseenter:mouseleave"
                   container="body">
                <span>{{contact.Value.Civility ? contact.Value.Civility + ' ' : ''}}{{contact.Value.Lastname}} {{contact.Value.Firstname}}</span>
                <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le contact" (click)="contact.Key = !contact.Key">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{contact.Value.Lastname}} {{contact.Value.Firstname}}"></i>
                </span>
              </div>
              <ng-template #contactPopover>
                <div><span class="q-bold q-c-main">email : </span><span>{{ !contact.Value.Email ? 'non renseigné' : contact.Value.Email}}</span></div>
                <div><span class="q-bold q-c-main">tel : </span><span>{{ !contact.Value.PhoneNumber ? 'non renseigné' : contact.Value.PhoneNumber}}</span></div>
                <div><span class="q-bold q-c-main">fixe : </span><span>{{ !contact.Value.MobilePhoneNumber ? 'non renseigné' : contact.Value.MobilePhoneNumber}}</span></div>
              </ng-template>
            </ng-container>
          </ng-container>

      </div>
        <!-- add affaires -->
        <div class="col-12 mt-4 mb-2" *ngIf="dataRdv.ListAffaires && dataRdv.ListAffaires.length > 0">
          <button type="button" class="q-btn q-secondary q-btn-add" title="Ajouter un dossier" [ngbPopover]="popDossierContent" [popoverTitle]="popDossierTitle" placement="bottom" popoverClass="q-popover" autoClose="true" *ngIf="dataRdv.IsModeAffaire">
            <span class="ml-2">Dossier</span>
            <i class="fas fa-plus float-right mt-1 mr-1"></i>
          </button>
        </div>
        <!-- list affaires -->
        <div class="col-12 p-3 q-zone-participant" *ngIf="dataRdv && dataRdv.ListAffaires && afficheZoneParticipant(dataRdv.ListAffaires)">
          <!--<ng-container *ngFor="let affaire of dataRdv.ListAffaires">-->
          <ng-container *ngIf="dataRdv.RdvSelectedAffaire && dataRdv.RdvSelectedAffaire.Selected">
            <div class="row q-line-user px-2">
              <span>{{dataRdv.RdvSelectedAffaire.Text}}</span>
              <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le dossier" (click)="addAffaire(dataRdv.RdvSelectedAffaire)">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{dataRdv.RdvSelectedAffaire.Text}}"></i>
              </span>
            </div>
          </ng-container>
          <!--</ng-container>-->
        </div>
        <!-- add participants -->
        <div class="col-12 mt-4 mb-2">
          <button type="button" class="q-btn q-secondary q-btn-add" title="Ajouter des participants" [ngbPopover]="popParticipantContent" [popoverTitle]="popParticipantTitle" placement="bottom" popoverClass="q-popover" [autoClose]="'outside'">
            <span class="ml-2">Collaborateur</span>
            <i class="fas fa-plus float-right mt-1 mr-1"></i>
          </button>
        </div>
        <!-- list participants -->
        <div class="col-12 p-3 q-zone-participant" *ngIf="dataRdv && dataRdv.ListParticipants && afficheZoneParticipantBT(dataRdv.ListParticipants.Children)">
          <ng-container *ngFor="let groupe of dataRdv.ListParticipants.Children; let j = index">
            <ng-container *ngIf="oneUserCheckInGrp(groupe)">
              <!--<div class="w-100 q-c-main">
          <strong>{{groupe.Text}} :</strong>
        </div>-->
              <ng-container *ngFor="let user of groupe.Children; let i = index;">
                <ng-container *ngIf="user.IsChecked && user.IsVisible">
                  <div class="row q-line-user px-2">
                    <span>{{user.Text}}</span>
                    <span class="fa-stack fa-xs q-c-danger q-btn-partdelete float-right ml-auto" title="retirer le collaborateur" (click)="addCollabo(groupe, user)">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-trash-alt fa-stack-1x fa-inverse" title="Retirer {{user.Text}}"></i>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- end  left column -->
    <!-- init right column -->
    <div class="col-md-8 col-lg-9">
      <q-bodisplay [param]="param" [globalsave]="globalSave" (sendEvent)="getIdBoRdv($event)" (sendBoReady)="pageLoaded($event)"></q-bodisplay>
    </div>
    <!-- end right column -->
  </div>
  <!-- end  body content -->
</div>

<!-- Modal suppression fichier -->
<!--<button class="d-none" data-toggle="modal" data-target="#ModalDelete" #modalDeleteBtn></button>-->
<div class="modal fade" id="ModalDelete" tabindex="-1" role="dialog" aria-labelledby="ModalDelete" aria-hidden="true" #deleteModal>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title ml-3"> Suppression d'un Rendez-vous</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalDelete()" #closeDelete>
          <!--<span aria-hidden="true">+</span>-->
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <br />
          <div class="row justify-content-center">
            Voulez-vous vraiment supprimer ce rendez-vous ?
          </div>
          <br />
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
              <div class="row justify-content-center">
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
                  <button type="button" class="btn btn-success" (click)="confirmDelete()">Oui <i class="fas fa-check ml-2"></i></button>
                </div>
                <br />
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
                  <button type="button" class="btn btn-danger" (click)="closeModalDelete()">Non <i class="fas fa-times ml-2"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template #popContactTitle>Choisir les contacts</ng-template>
<ng-template #popContactContent>
  <ng-container *ngIf="dataRdv && dataRdv.ListContacts">
    <div class="p-2">
      <ng-container *ngFor="let contact of dataRdv.ListContacts">
        <ng-container *ngIf="!contact.Key">
          <div class="q-line-adduser" (click)="contact.Key = !contact.Key">
            <span>{{contact.Value.Lastname}} {{contact.Value.Firstname}}</span>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter {{contact.Value.Lastname}} {{contact.Value.Firstname}}"></i>
            </span>
            <hr class="m-0" />
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-template>


<ng-template #popDossierTitle>Choisir de dossier à rattacher</ng-template>
<ng-template #popDossierContent>
  <ng-container *ngIf="dataRdv && dataRdv.ListAffaires">
      <ng-container *ngFor="let affaire of dataRdv.ListAffaires">
        <ng-container *ngIf="!affaire.Selected">
          <div class="q-line-adduser" (click)="addAffaire(affaire)">
            <span>{{affaire.Text}}</span>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter {{affaire.Text}}"></i>
            </span>
            <hr class="m-0" />
          </div>
        </ng-container>
      </ng-container>
  </ng-container>
</ng-template>


<ng-template #popParticipantTitle>Choisir les participants</ng-template>
<ng-template #popParticipantContent>
  <ng-container *ngIf="dataRdv && dataRdv.ListParticipants && dataRdv.ListParticipants.Children.length > 0">
    <div class="p-2">
      <ng-container *ngFor="let groupe of dataRdv.ListParticipants.Children">
        <ng-container *ngIf="groupe.Children && groupe.Children.length > 0 && !allUserCheckInGrp(groupe)">
          <div class="my-3">
            <strong>{{groupe.Text}} :</strong>
            <span class="fa-stack fa-xs float-right mr-2 q-c-main" (click)="addGrpCollabo(groupe)">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter tous les {{groupe.Text}}"></i>
            </span>
            <hr class="m-0" />
          </div>
        </ng-container>
        <ng-container *ngIf="groupe.Children.length > 0">
          <ng-container *ngFor="let user of groupe.Children">
            <ng-container *ngIf="!user.IsChecked">
              <div class="q-line-adduser" (click)="addCollabo(groupe, user)">
                <span>{{user.Text}}</span>
                <span class="fa-stack fa-xs float-right mr-2 q-c-main q-btn-addpart">
                  <i class="fas fa-circle fa-stack-2x"></i>
                  <i class="fas fa-plus fa-stack-1x fa-inverse" title="Ajouter {{user.Text}}"></i>
                </span>
                <hr class="m-0" />
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="!dataRdv.ListParticipants">
    Aucun collaborateur à ajouter
  </ng-container>
</ng-template>

<ng-template #ConfirmUpdate let-confirmUpdate>
  <div class="modal-body">
    <div class="row px-4 justify-content-center">
      <h5 class="modal-title big-title" id="exampleModalLongTitle">Le rendez-vous a été supprimé dans votre agenda Google</h5>
    </div>
    <div class="row px-4 justify-content-center">
      <p class="q-bold q-c-main">Que souhaitez-vous faire ?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="q-btn q-main" (click)="SaveFromModal(true)">
      Enregistrer mes modifications et recréer dans Google
    </button>
    <button type="button" class="q-btn q-danger" (click)="SaveFromModal(false)">
    Supprimer
    </button>
  </div>
</ng-template>
